const SIGN_IN_PATH = "/auth/sign-in";

/**
 * The sign-in URL that brings the user back to `path` once signed in. `/`
 * needs no return: it is where sign-in lands anyway.
 */
export function signInUrlReturningTo(path: string): string {
  if (!path || path === "/") return SIGN_IN_PATH;
  return `${SIGN_IN_PATH}?redirectTo=${encodeURIComponent(path)}`;
}

/**
 * `redirectTo` comes from the URL, so anyone can craft it: only a path on
 * this origin is followed, never another site nor a `javascript:` URL.
 */
export function safeRedirectPath(
  redirectTo: string | null,
  origin: string = window.location.origin,
): string | null {
  if (!redirectTo) return null;
  try {
    const url = new URL(redirectTo, origin);
    if (url.origin !== origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
